// extracted by mini-css-extract-plugin
export default {"mobile":"(max-width: 600px)","app":"src_app__6LyV9","heightAuto":"src_heightAuto__h1Wz2","container":"src_container__yFcXH","mainContent":"src_mainContent__8Cle2"};